import React from "react";
import FooterPages from "./Footer/FooterPages";
import Navbar3 from "./Navbars/Navbar3";
import UserService from "../services/UserService";
import { motion } from "framer-motion"; // for smooth animations
import { FaExclamationTriangle } from "react-icons/fa";

function PageNotFound() {
  const getMessage = () => {
    if (!UserService.isLoggedIn()) {
      return "Please login to access!!";
    }
    return UserService.hasRole(["adminrole"])
      ? "Please login to access!!"
      : "Please login with Admin user to access!!";
  };

  return (
    <>
      <Navbar3 />
      <div className="bgpages min-vh-100 d-flex flex-column">
        <div className="container flex-grow-1 d-flex align-items-center justify-content-center">
          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Error Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mb-3"
            >
              <FaExclamationTriangle
                className="text-warning"
                size={60}
                style={{ filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }}
              />
            </motion.div>

            {/* Heading */}
            <div
              className="p-3 bg-white shadow-sm rounded mb-3"
              style={{ fontSize: "22px", fontWeight: "600" }}
            >
              🚧 Page Not Found
            </div>

            {/* Message */}
            <motion.div
              className="card p-3 shadow-sm border-0 mx-auto"
              style={{ maxWidth: "500px" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.7 }}
            >
              <div className="text-muted">{getMessage()}</div>
            </motion.div>

            {/* Action Button */}
            <motion.div
              className="mt-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <a href="/" className="btn btn-success px-4 py-2 rounded-pill shadow-sm">
                ⬅ Go Back Home
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
      <FooterPages />
    </>
  );
}

export default PageNotFound;
